import { ApplicationState } from '../../types';

export const selectJobId = ({ storyboard }: ApplicationState) => storyboard.jobId;

export const selectJobIdIsPending = ({ storyboard }: ApplicationState) => storyboard.isPending;

export const selectJobParams = ({ storyboard }: ApplicationState) => storyboard.params;
